<template>
	<h1>Add level</h1>
	<form @submit.prevent="submit" class="form-container">
		<div class="input-container">
			<label for="Difficulty">Level</label>
			<input
				type="text"
				class="form-control"
				v-model="form.name"
				id="Level"
				placeholder="Level"
			/>
		</div>
		<div class="input-container">
			<label for="Difficulty">Ordre</label>
			<input v-model="form.order" type="number" />
		</div>
		<p v-if="status !== ''" class="status">{{ status }}</p>
		<p class="errors">{{ errors }}</p>
		<input class="submit dark" type="submit" value="Valider" />
	</form>
</template>

<script>

export default {
	data() {
		return {
			form: {
				name: '',
				order: null
			},
			errors: '',
			status: ''
		}
	},
	methods: {
		submit() {
			this.$store.dispatch('addLevel', this.form)
				.then(() => {
					this.status = 'Enregistré avec succès'
					this.form.name = ""
					setTimeout(() => {
						this.status = ''
					}, 2000)
				})
		},
	},
}
</script>

<style>
</style>
